export default __webpack_public_path__ + "static/media/fact1.3244c821.svg";